import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, throwError } from "rxjs";
import { environment } from "../../../environments/environment";
import { ApiError } from "../models/api-response.model";

@Injectable({ providedIn: 'root' })
export class ApiService {

  private base = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}


  private request<T>(method: string, url: string, options?: {
    body?: any;
    params?: any;
  }) {
    return this.http.request<T>(method, this.base + url, {
    body: options?.body,
    params: options?.params,
    withCredentials: true,
  }).pipe(
      catchError((err: HttpErrorResponse) => {
        const apiError: ApiError = {
          statusCode: err.status,
          message: err.error?.message || err.message || 'Unexpected error',
          errors: err.error?.errors
        };
        return throwError(() => apiError);

      })
    );
  }

  post<T>(url: string, body: any) {
    return this.request<T>('POST', url, { body });
  }

  get<T>(url: string, params?: any) {
    return this.request<T>('GET', url, { params });
  }

  patch<T>(url: string, body: any) {
    return this.request<T>('PATCH', url, { body });
  }

  /** (optional but recommended) */
  put<T>(url: string, body: any) {
    return this.request<T>('PUT', url, { body });
  }

  delete<T>(url: string) {
    return this.request<T>('DELETE', url);
  }
}
